import React from "react";
import "./Input.scss";
import classNames from "classnames";
import Button from "../Button/Button.js";

const Input = ({
  value,
  handleChange,
  placeholder,
  label,
  handleClick,
  validateFn,
  isLoading,
  disabled
}) => {
  const isDisabled = !validateFn(value) || disabled;

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !isDisabled) {
      handleClick();
    }
  };

  return (
    <div className={classNames("tmx-input")}>
      <input
        type="email"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="tmx-input__input"
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
      <Button
        handleClick={handleClick}
        isDisabled={isDisabled}
        label={label}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Input;
